module.exports = __webpack_public_path__ + "static/2gerencia_proyectos_nf-652ed9644b7c91b38dfb1022d977c715.png";